var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"border-radius-s",staticStyle:{"width":"32px"},attrs:{"src":_vm.paymentCardSource}})}
var staticRenderFns = []

export { render, staticRenderFns }